<script setup>
defineProps({
  change: {
    type: Object,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <div
    :class="[
      change.current
        ? 'bg-gray-50 text-indigo-600'
        : 'text-gray-700 hover:bg-gray-300 hover:text-indigo-600',
      ' cursor-pointer rounded-md pl-2 leading-6',
    ]"
  >
    <div class="text-xs font-semibold">
      {{ change.convict.name }}
    </div>
    <div class="line-clamp-1 text-xs">
      {{ description }}
    </div>
  </div>
</template>
